import { SELECTOR_COMBINATORS } from '../common.mjs';
import MasterCSS from '../core.mjs';
import parsePair from './parse-pair.mjs';

const SELECTOR_REGEX = new RegExp(`(?:[a-zA-Z0-9-]+)|([${SELECTOR_COMBINATORS.join('')}#.:,*])|(a-zA-Z0-9-)`, 'g');
function parseSelector(token, css = new MasterCSS(), isRaw = true) {
    const resolve = (eachToken)=>{
        const nodes = [];
        let currentPrefix = '';
        let tokenIndex = 0;
        for (const match of eachToken.matchAll(SELECTOR_REGEX)){
            const raw = match[0];
            tokenIndex += raw.length;
            if (raw === ':' || raw === '.' || raw === '#') {
                currentPrefix += raw;
                continue;
            }
            let type;
            let value = raw;
            const definedNodes = css.selectors.get(currentPrefix + raw);
            if (definedNodes) {
                const firstNode = definedNodes[definedNodes.length - 1];
                nodes.push(definedNodes.length === 1 && firstNode.type ? {
                    ...firstNode,
                    raw: currentPrefix + raw
                } : {
                    children: definedNodes,
                    raw: currentPrefix + raw
                });
                currentPrefix = '';
                continue;
            }
            if (SELECTOR_COMBINATORS.includes(raw)) {
                type = 'combinator';
                if (raw === '_') {
                    const nextRawValue = eachToken[tokenIndex];
                    const prevRawValue = eachToken[tokenIndex - raw.length - 1];
                    if (prevRawValue !== '_' && nextRawValue !== '_') {
                        value = ' ' // support BEM __
                        ;
                    }
                }
            } else if (raw === ',') {
                type = 'separator';
            } else if (raw === '*') {
                type = 'universal';
            } else if (currentPrefix === ':') {
                type = 'pseudo-class';
            } else if (currentPrefix === '::') {
                type = 'pseudo-element';
            } else if (currentPrefix === '.') {
                type = 'class';
            } else if (currentPrefix === '#') {
                type = 'id';
            }
            nodes.push({
                value,
                ...isRaw && {
                    raw: currentPrefix + raw
                },
                ...type && {
                    type
                }
            });
            currentPrefix = '';
        }
        return nodes;
    };
    const pair = (eachToken, nodes = [])=>{
        const paired = parsePair(eachToken);
        if (paired) {
            let { pre, body, post } = paired;
            let name;
            if (body) {
                const lastColonIndex = pre.lastIndexOf(':');
                if (lastColonIndex !== -1) {
                    name = pre.slice(lastColonIndex);
                    pre = pre.slice(0, lastColonIndex);
                }
            }
            if (pre) nodes.push(...pair(pre));
            if (body) {
                const children = pair(body);
                if (name) {
                    const node = resolve(name)[0];
                    if (children.length) node.children = children;
                    nodes.push(node);
                } else {
                    nodes.push(...children);
                }
            }
            if (post) nodes.push(...pair(post));
            return nodes;
        }
        const attrPaired = parsePair(eachToken, '[', ']');
        if (attrPaired) {
            const { pre, body, post } = attrPaired;
            if (pre) nodes.push(...pair(pre));
            nodes.push({
                value: body,
                type: 'attribute',
                ...isRaw && {
                    raw: `[${body}]`
                }
            });
            if (post) nodes.push(...pair(post));
            return nodes;
        }
        return resolve(eachToken);
    };
    return pair(token);
}

export { parseSelector as default };
